import { useEffect, RefObject } from 'react';

export const useDialogFocus = (
  open: boolean,
  containerRef?: RefObject<HTMLElement | null>
) => {
  useEffect(() => {
    if (open && containerRef?.current) {
      const timeoutId = setTimeout(() => {
        if (containerRef.current) {
          try {
            containerRef.current.focus();
          } catch (e) {
            // Focus failed silently
          }
        }
      }, 100);
      return () => clearTimeout(timeoutId);
    }
  }, [open, containerRef]);
};
